export const initialValues = () => {
  return {
    vehicleData: {
      model: {
        manufacturer: "",
        name: "",
        descriptionLong: "",
        year: "",
        code: "",
      },
      recommendedRetailPriceAmount: {
        amount: "",
      },
      retailPriceAmount: {
        amount: "",
      },
      isUsed: "",
      vin: "",
      deliveryData: {
        deliveryDate: "",
      },
      initialRegistrationDate: "",
      odometer: "",
      orderDate: "",
    },
  };
};
